// extracted by mini-css-extract-plugin
module.exports = {"alert":"AlertMessage_alert_1zr9i","warning":"AlertMessage_warning_aQcLV","info":"AlertMessage_info_2JQjG","success":"AlertMessage_success_3bshx"};